






















































import Vue from "vue"

/* eslint-disable */

import { Dealer } from "../models/Dealer"
import { Make } from '../models/Make'
/* es-lint-enable */

export default Vue.extend({
  computed: {
    cols(): number {
      const { xs, sm } = this.$vuetify.breakpoint
      return xs || sm ? 12 : 4
    },
    currentDealer(): Dealer {
      return this.$store.state.dealers.currentDealer
    },
    currentMake() : Make {
      return this.$store.state.makes.currentMake
    },
  },
})
